import styled from 'styled-components'
import tokens from '@gympass/yoga-tokens'
import { Body2 } from '@components/Typography'
import { CircularProgress } from '@material-ui/core'
import { Card as YogaCard, Button } from '@gympass/yoga'
import { Body1, H6 } from '@components/Text'

export const Card = styled(YogaCard)`
  padding: 24px;
  margin-top: 40px;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    margin-top: 16px;
    margin-bottom: 8px;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-top: -65px;
    margin-bottom: 8px;
    padding: 40px;
  }
`

export const CardHeader = styled(YogaCard.Header)`
  margin-bottom: 15px;
  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-bottom: 24px;
  }
`

export const CardTitle = styled(H6)`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #001027;
  margin: 0;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    font-size: 24px;
    line-height: 29px;
  }
`

export const CardContent = styled(YogaCard.Content)`
  margin-bottom: 32px;
`

export const CardActions = styled(YogaCard.Actions)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 8px;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-bottom: 0;
  }
`

export const PriceRow = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

  &:last {
    margin-bottom: 23px;
  }
`
export const PriceDescription = styled(Body1)`
  font-weight: normal;
  line-height: 16px;
  color: ${tokens.colors.deep};

  span {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #001027;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    font-size: 14px;
    line-height: 17px;
  }
`

export const PriceValue = styled(Body1)`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: right;

  em {
    text-decoration-line: line-through;
    font-style: normal;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    font-size: 14px;
    line-height: 17px;
  }
`

export const Divider = styled.hr`
  margin-top: 16px;
  margin-bottom: 16px;
  border: none;
  height: 1px;
  background-color: #000000;
  opacity: 0.15;
`

export const TotalWrapper = styled(H6)`
  font-weight: normal;

  em {
    font-size: 24px;
    text-decoration: none;
    text-transform: capitalize;
  }

  span {
    margin-left: 2px;
    font-size: 24px;
    font-weight: 500;
  }
`

export const LinkButton = styled(Button.Link)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  text-decoration-line: underline;
  color: var(--vibin);
  margin-top: 25px;
  margin-bottom: 0;

  &:not([disabled]):hover {
    color: rgba(216, 56, 94, 0.5);
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-bottom: 0;
  }
`

export const CouponWrapper = styled.section`
  display: flex;
  flex-direction: column;
  border-radius: 100px;
  width: 100%;
`

export const Form = styled.section`
  display: flex;
  border-radius: 100px;
  border: 1px solid #dce0ed;
  padding: 8px;
`

export const Input = styled.input`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  padding: 0 24px;
  border: none;
  width: 100%;
  outline: 0;
  border-radius: 100px;
`

export const CouponRow = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`

export const ErrorMessage = styled(Body2)`
  flex: 1;
  font-size: 16px;
  color: #f46152;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    font-size: 12px;
    line-height: 16px;
  }
`

export const CancelCoupon = styled(Button.Link)`
  display: flex;
  align-items: center;
  color: var(--vibin);

  margin: 0 0 0 auto;
  text-decoration: underline;
  font-weight: 500;

  &:not([disabled]):hover {
    color: rgba(216, 56, 94, 0.5);
  }

  svg {
    width: 12px;
    margin-right: 2px;
  }
`

export const Progress = styled(CircularProgress)`
  &.MuiCircularProgress-colorPrimary {
    color: #ffffff;
  }
`

export const ButtonText = styled(H6)`
  font-weight: 500;
`
export const StrippedValue = styled.s`
  padding-right: 5px;
  color: var(--secondary-text);
`

export const FreeValue = styled.span`
  color: ${tokens.colors.vibin};
`
